module.exports = __webpack_public_path__ + "img/southeast-fall-1920x550.eaa04533.jpg";